module.exports = __webpack_public_path__ + "static/ClickedBaggageDelay-c55000e0a66715c89c3035cb34db9af5.png";